module.exports = __webpack_public_path__ + "catalog/items/firesafety/First-Aid-Green/First-Aid-Green.svg";